// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import { BoolValue, BoolValueT } from "./bool-value";
import { ByteValue, ByteValueT } from "./byte-value";
import { DoubleValue, DoubleValueT } from "./double-value";
import { FloatValue, FloatValueT } from "./float-value";
import { IntValue, IntValueT } from "./int-value";
import { LongValue, LongValueT } from "./long-value";
import { ShortValue, ShortValueT } from "./short-value";
import { StringValue, StringValueT } from "./string-value";
import { UByteValue, UByteValueT } from "./ubyte-value";
import { UIntValue, UIntValueT } from "./uint-value";
import { ULongValue, ULongValueT } from "./ulong-value";
import { UShortValue, UShortValueT } from "./ushort-value";

export enum Value {
  NONE = 0,
  BoolValue = 1,
  ByteValue = 2,
  UByteValue = 3,
  ShortValue = 4,
  UShortValue = 5,
  IntValue = 6,
  UIntValue = 7,
  LongValue = 8,
  ULongValue = 9,
  FloatValue = 10,
  DoubleValue = 11,
  StringValue = 12,
}

export function unionToValue(
  type: Value,
  accessor: (
    obj:
      | BoolValue
      | ByteValue
      | DoubleValue
      | FloatValue
      | IntValue
      | LongValue
      | ShortValue
      | StringValue
      | UByteValue
      | UIntValue
      | ULongValue
      | UShortValue,
  ) =>
    | BoolValue
    | ByteValue
    | DoubleValue
    | FloatValue
    | IntValue
    | LongValue
    | ShortValue
    | StringValue
    | UByteValue
    | UIntValue
    | ULongValue
    | UShortValue
    | null,
):
  | BoolValue
  | ByteValue
  | DoubleValue
  | FloatValue
  | IntValue
  | LongValue
  | ShortValue
  | StringValue
  | UByteValue
  | UIntValue
  | ULongValue
  | UShortValue
  | null {
  switch (Value[type]) {
    case "NONE":
      return null;
    case "BoolValue":
      return accessor(new BoolValue())! as BoolValue;
    case "ByteValue":
      return accessor(new ByteValue())! as ByteValue;
    case "UByteValue":
      return accessor(new UByteValue())! as UByteValue;
    case "ShortValue":
      return accessor(new ShortValue())! as ShortValue;
    case "UShortValue":
      return accessor(new UShortValue())! as UShortValue;
    case "IntValue":
      return accessor(new IntValue())! as IntValue;
    case "UIntValue":
      return accessor(new UIntValue())! as UIntValue;
    case "LongValue":
      return accessor(new LongValue())! as LongValue;
    case "ULongValue":
      return accessor(new ULongValue())! as ULongValue;
    case "FloatValue":
      return accessor(new FloatValue())! as FloatValue;
    case "DoubleValue":
      return accessor(new DoubleValue())! as DoubleValue;
    case "StringValue":
      return accessor(new StringValue())! as StringValue;
    default:
      return null;
  }
}

export function unionListToValue(
  type: Value,
  accessor: (
    index: number,
    obj:
      | BoolValue
      | ByteValue
      | DoubleValue
      | FloatValue
      | IntValue
      | LongValue
      | ShortValue
      | StringValue
      | UByteValue
      | UIntValue
      | ULongValue
      | UShortValue,
  ) =>
    | BoolValue
    | ByteValue
    | DoubleValue
    | FloatValue
    | IntValue
    | LongValue
    | ShortValue
    | StringValue
    | UByteValue
    | UIntValue
    | ULongValue
    | UShortValue
    | null,
  index: number,
):
  | BoolValue
  | ByteValue
  | DoubleValue
  | FloatValue
  | IntValue
  | LongValue
  | ShortValue
  | StringValue
  | UByteValue
  | UIntValue
  | ULongValue
  | UShortValue
  | null {
  switch (Value[type]) {
    case "NONE":
      return null;
    case "BoolValue":
      return accessor(index, new BoolValue())! as BoolValue;
    case "ByteValue":
      return accessor(index, new ByteValue())! as ByteValue;
    case "UByteValue":
      return accessor(index, new UByteValue())! as UByteValue;
    case "ShortValue":
      return accessor(index, new ShortValue())! as ShortValue;
    case "UShortValue":
      return accessor(index, new UShortValue())! as UShortValue;
    case "IntValue":
      return accessor(index, new IntValue())! as IntValue;
    case "UIntValue":
      return accessor(index, new UIntValue())! as UIntValue;
    case "LongValue":
      return accessor(index, new LongValue())! as LongValue;
    case "ULongValue":
      return accessor(index, new ULongValue())! as ULongValue;
    case "FloatValue":
      return accessor(index, new FloatValue())! as FloatValue;
    case "DoubleValue":
      return accessor(index, new DoubleValue())! as DoubleValue;
    case "StringValue":
      return accessor(index, new StringValue())! as StringValue;
    default:
      return null;
  }
}

export type ValueT =
  | { type: "NONE"; value: null }
  | { type: "BoolValue"; value: BoolValueT }
  | { type: "ByteValue"; value: ByteValueT }
  | { type: "UByteValue"; value: UByteValueT }
  | { type: "ShortValue"; value: ShortValueT }
  | { type: "UShortValue"; value: UShortValueT }
  | { type: "IntValue"; value: IntValueT }
  | { type: "UIntValue"; value: UIntValueT }
  | { type: "LongValue"; value: LongValueT }
  | { type: "ULongValue"; value: ULongValueT }
  | { type: "FloatValue"; value: FloatValueT }
  | { type: "DoubleValue"; value: DoubleValueT }
  | { type: "StringValue"; value: StringValueT };
